import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageListingAuto = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 41.183 47.729",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Sideultlisting_Auto",
		transform: "translate(-1397.668 -1087.123)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_3106",
			"data-name": "Group 3106",
			transform: "translate(0 228.418)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_3104",
					"data-name": "Group 3104",
					transform: "translate(-1 163.842)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "library_books_FILL0_wght300_GRAD0_opsz48",
						d: "M120.085,213.207H134.45v-1.842H120.085Zm0-3.982H134.45v-1.842H120.085Zm-3.245,10.661a2.368,2.368,0,0,1-2.342-2.342v-27.2A2.368,2.368,0,0,1,116.841,188H137.7a2.368,2.368,0,0,1,2.342,2.342v27.2a2.368,2.368,0,0,1-2.342,2.342Zm0-1.842H137.7a.537.537,0,0,0,.5-.5v-27.2a.537.537,0,0,0-.5-.5h-20.86a.537.537,0,0,0-.5.5v27.2a.537.537,0,0,0,.5.5Zm-4.5,6.339A2.368,2.368,0,0,1,110,222.041v-22.7h1.842v22.7a.537.537,0,0,0,.5.5h22.7v1.842Zm4-34.54v0Z",
						transform: "translate(1299.809 518.209)"
					}), /* @__PURE__ */ _jsx("path", {
						id: "image_FILL0_wght300_GRAD0_opsz48",
						d: "M147.232,262.18h14.26l-4.3-5.725-4.01,5.112L150.45,258l-3.218,4.176Z",
						transform: "translate(1272.814 457.233)"
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "magic_button_FILL0_wght300_GRAD0_opsz48",
					d: "M571.778-418.965l-1.9-4.27-4.259-1.909,4.252-1.938,1.911-4.225,1.955,4.225,4.225,1.938-4.227,1.909Z",
					transform: "translate(832.053 1297.867)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "magic_button_FILL0_wght300_GRAD0_opsz48-2",
					"data-name": "magic_button_FILL0_wght300_GRAD0_opsz48",
					d: "M570.036-422.455l-1.366-3.063-3.055-1.37,3.05-1.39,1.371-3.03,1.4,3.03,3.03,1.39-3.032,1.37Z",
					transform: "translate(839.969 1290.014)"
				})
			]
		})
	})
});
export default SvgPageListingAuto;
